module.exports = __webpack_public_path__ + "img/12angry-2.40e60911.jpg";